// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconPIPCollapse(Props) {
  var className = Props.className;
  var tmp = {
    height: "19",
    width: "22",
    fill: "none",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M0.642216 0C0.642216 0 0.638786 1.45507 0.638786 3.25C0.638786 5.04493 0.638672 16 0.638672 16C0.638672 16 2.09386 16 3.88879 16H9.63879V12C9.63879 10.3431 10.9819 9 12.6388 9H19.6388C19.9894 9 20.326 9.0602 20.6388 9.1707V3.25C20.6388 1.45507 20.6388 0 20.6388 0H0.642216ZM4.91912 3.21967L8.13879 6.43934V4.75C8.13879 4.33579 8.47458 4 8.88879 4C9.30299 4 9.63879 4.33579 9.63879 4.75V8.25C9.63879 8.6642 9.30299 9 8.88879 9H5.38879C4.97458 9 4.63879 8.6642 4.63879 8.25C4.63879 7.8358 4.97458 7.5 5.38879 7.5H7.07812L3.85846 4.28033C3.56557 3.98744 3.56557 3.51256 3.85846 3.21967C4.15135 2.92678 4.62623 2.92678 4.91912 3.21967ZM20.6388 10.2676C20.3446 10.0974 20.0031 10 19.6388 10H12.6388C11.5342 10 10.6388 10.8954 10.6388 12V17C10.6388 18.1046 11.5342 19 12.6388 19H19.6388C20.7434 19 21.6388 18.1046 21.6388 17V12C21.6388 11.2597 21.2366 10.6134 20.6388 10.2676Z",
    fill: "currentColor"
  }));
}
IconPIPCollapse.displayName = "IconPIPCollapse";
var make = IconPIPCollapse;
export { make };
/* react Not a pure module */